import * as React from 'react';
import { ModalView } from '@cian/ui-kit/prev';
import { QuizComponent } from '@cian/quiz-component';
import { caShowFirstQuestion, caShowSecondQuestion, caOpenThankYouModal, caCloseQuiz } from './tracking';
import { IGetQuestionRequest, IGetQuestionResponse } from '../../../../shared/repositories/quiz/v1/get-question';

export interface IQuizModal {
  quizId: number;
  isModalOpen: boolean;
  getQuestions(params?: IGetQuestionRequest): Promise<IGetQuestionResponse | null>;
  closeModal(): void;
  closeQuizModalWithTimer(ms: number): void;
}

export const QuizModal: React.FC<IQuizModal> = ({
  quizId,
  isModalOpen,
  getQuestions,
  closeModal,
  closeQuizModalWithTimer,
}) => {
  const handleClose = () => {
    caCloseQuiz();
    closeModal();
  };

  return (
    <ModalView
      custom={{
        backgroundOpacity: '1',
        crossColor: '999999',
        open: isModalOpen,
      }}
      styles={{
        backgroundColor: 'FFFFFF',
        borderColor: 'F4F4F4',
        boxShadow: '',
        height: '',
        width: '',
        zIndex: '10',
      }}
      onClose={handleClose}
    >
      <QuizComponent
        quizId={quizId}
        getQuestions={getQuestions}
        caShowFirstQuestion={caShowFirstQuestion}
        caShowSecondQuestion={caShowSecondQuestion}
        caOpenThankYouModal={caOpenThankYouModal}
        closeQuizModalWithTimer={closeQuizModalWithTimer}
      />
    </ModalView>
  );
};
